import { getBillingName, } from '@debbie/common/dist/economy/billing/index.js';
import { Site } from '@debbie/common/dist/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as billingsAPI from '@debbie/cortex/dist/api/billing.js';
import { useAllCreditors } from '@debbie/cortex/dist/creditors/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import THEME from '../theme.js';
import { errorNotification } from '../utils/errors.js';
import { Send } from './Icons/index.js';
import PlusSquare from './Icons/PlusSquare.js';
import X from './Icons/X.js';
import { Badge, CopyToClipboard } from './index.js';
export const getBillingIdentity = (billing, lang) => getBillingName(billing);
const Billing = (props) => {
    const { billing } = props;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const allCreditorsLoadable = useAllCreditors();
    const allCreditors = h.hasData(allCreditorsLoadable)
        ? allCreditorsLoadable.data
        : null;
    const creditor = allCreditors &&
        allCreditors.find((c) => c.creditorId === billing.creditorId);
    const identity = getBillingIdentity(billing, lang);
    const sendBillingMutation = useMutation(async () => {
        await billingsAPI.sendBillings([billing.billingId]);
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.billing);
        },
    });
    return (React.createElement("tr", { onClick: props.onClick },
        React.createElement("td", { style: { width: '40px' } },
            React.createElement(PlusSquare, { style: { cursor: 'pointer' } })),
        React.createElement("td", { style: { width: '1px' } }, moment(billing.date).isAfter(moment().startOf('day')) && React.createElement(Circle, null)),
        React.createElement("td", { style: { width: '1%', whiteSpace: 'nowrap' } },
            React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, billing.handle
                ? // @ts-ignore
                    lang.systemTankHandles[billing.handle] || billing.handle
                : '-')),
        React.createElement("td", { style: { width: '1%', whiteSpace: 'nowrap', fontSize: '0.8em' } },
            React.createElement(CopyToClipboard, { text: identity }, identity)),
        React.createElement("td", { title: moment(billing.date).format(THEME.DATE_FORMAT_LONG), style: { width: '140px', fontSize: '0.8em' } }, moment(billing.date).format(THEME.DATE_FORMAT)),
        React.createElement("td", { style: { fontSize: '0.8em', fontWeight: 900 } }, creditor &&
            (site == Site.Caseworker ? (React.createElement(Link, { style: { color: 'inherit' }, to: `/creditors/${creditor.creditorId}` }, creditor.name)) : (creditor.name))),
        React.createElement("td", { style: { fontSize: '0.8em' } }),
        React.createElement("td", { style: { textAlign: 'right', width: '1%', whiteSpace: 'nowrap' } }),
        React.createElement("td", { style: { textAlign: 'right', width: '1%', whiteSpace: 'nowrap' } }),
        React.createElement("td", { style: { width: '40px' } },
            React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, billing.currency)),
        React.createElement("td", { style: { width: '40px' } },
            React.createElement(X, { style: { cursor: 'pointer' }, onClick: () => { } })),
        React.createElement("td", { style: { width: '40px' } }, !billing.billingEmailed && (React.createElement(Send, { style: {
                ...(sendBillingMutation.isLoading
                    ? { pointerEvents: 'none' }
                    : {}),
                cursor: 'pointer',
                height: '18px',
                width: '18px',
            }, onClick: () => sendBillingMutation.mutate() })))));
};
export default Billing;
const CIRCLE_WIDTH = 7;
const Circle = styled.div `
  height: ${CIRCLE_WIDTH}px;
  width: ${CIRCLE_WIDTH}px;
  margin-right: -${CIRCLE_WIDTH}px;
  background-color: ${THEME.COLOR_ACCENT};
  border-radius: 100%;
`;
//# sourceMappingURL=Billing.js.map